<template>
  <div class="top-pick-preferences top-pick-large">
    <a
      v-for="pill in pills"
      :key="'pill-' + pill"
      :class="[...baseClasses, { active: active === pill }]"
      @click.prevent="active = pill"
    >
      {{ pill }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    pills: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      active: null,
      baseClasses: ['top-pick-preference', 'hover']
    };
  }
};
</script>
